<template>
  <modal
    variant="drawer-no-scroll"
    no-footer
  >
    <template v-slot:default="{ activate }">
      <slot v-bind="{ activate, displayName }" />
    </template>

    <template v-slot:header>
      <div class="profile-input-title">
        <span>Switch language</span>
      </div>
    </template>

    <template v-slot:body="{ deactivate, getFocusableElements }">
      <language-switcher-list :languages="languages" @close="deactivate" @update-focusable="getFocusableElements" />
    </template>
  </modal>
</template>

<script>
import { mapState } from 'vuex'
import LanguageSwitcherList from './components/language-switcher-list.vue'
export default {
  name: 'language-switcher',
  components: {
    LanguageSwitcherList
  },
  props: {
    languages: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState('global', ['lang']),
    ...mapState('responsive', ['check']),
    currentLang() {
      return this.languages.find(l => (l.regionalIsoCode || l.iso)?.toLowerCase() === this.lang.toLowerCase())
    },
    displayName() {
      if (!this.currentLang) {
        return ''
      }
      return this.check.isMdAndDown ? this.currentLang.iso.toUpperCase() : this.currentLang.displayName
    }
  }
}
</script>